// extracted by mini-css-extract-plugin
module.exports = {"icon":"_5a7ea15","textWrapper":"_81b8151"};